import React from 'react'

import { Wordbook } from '@Components/Wordbook'
import { TacticAssortmentLadder } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from './AssortmentLadder.module.scss'

export const AssortmentLadder = ({ tactic }: { tactic?: TacticAssortmentLadder }) => {
  const { t } = useTranslation()

  if (!tactic || !tactic.items || tactic.items.length === 0) {
    return null
  }

  return (
    <div className={styles.assortmentLadder}>
      <p className={styles.title}>{t('products:PRODUCT_DETAILS')}</p>
      <dl>
        {tactic?.items?.map(item => (
          <div key={item?.id}>
            {item.iconURL && <img alt="" src={item.iconURL} />}
            {item.header && <dt><Wordbook wordbook={item.header} /></dt>}
            {item.text && <dd><Wordbook wordbook={item.text} /></dd>}
          </div>
        ))}
      </dl>
    </div>
  )
}
